import { getBranding } from '../branding';

export function Brand({ className = '' }: { className?: string }) {
  const branding = getBranding();
  const classes = ['brand', className].filter(Boolean).join(' ');
  return <span className={classes}>
    <img
      className="brand__wordmark"
      src={branding.assets.wordmark}
      alt={branding.productName}
      width={600}
      height={150}
      decoding="async"
    />
  </span>;
}

export function BrandLinks() {
  const branding = getBranding();
  const links = [
    branding.links.homepage ? { href: branding.links.homepage, label: branding.operatorName } : null,
    branding.links.privacy ? { href: branding.links.privacy, label: 'Privacy' } : null,
    branding.links.terms ? { href: branding.links.terms, label: 'Terms' } : null,
    branding.links.supportEmail ? { href: `mailto:${branding.links.supportEmail}`, label: 'Support' } : null,
  ].filter((link): link is { href: string; label: string } => Boolean(link));
  if (!links.length) return null;
  return <nav className="brand-links" aria-label="Product links">
    {links.map((link) => <a key={link.label} href={link.href} target={link.href.startsWith('https:') ? '_blank' : undefined} rel={link.href.startsWith('https:') ? 'noreferrer' : undefined}>{link.label}</a>)}
  </nav>;
}
